import LinkThirdpartyModal from './LinkThirdpartyModal';
export default LinkThirdpartyModal;
